import Image from 'next/image';

import TrustpilotLogo from './svgs/trustpilot-logo.svg';

export const IconTrustpilotLogo = () => (
  <Image src={TrustpilotLogo as string} alt="Trustpilot Logo" />
);
